import { RequestV5 } from '.';
var RequestBuilderV5 = (function () {
    function RequestBuilderV5() {
    }
    RequestBuilderV5.prototype.create = function (action) {
        var request = new RequestV5();
        var newAction = {
            Arguments: action.parameters,
            Name: action.serverEvent,
            ReceiverId: action.receiverId,
        };
        request.Actions = [newAction];
        request.Changed = [];
        return request;
    };
    return RequestBuilderV5;
}());
export { RequestBuilderV5 };
